import '../sticky-plans-column-headers.scss';
import '../comparison-table.scss';
import '../comparison-table-v3.scss';

import classNames from 'classnames';
import { useEffect, useRef } from 'react';

import { PlanBadgeTextContainer } from './PlanBadgeTextContainer';
import { Plans } from './Plans';
import type { ComparisonTablePlan } from '../types';

interface Props {
  plans: ComparisonTablePlan[];
  stickyHeaderOffset: number;
  variant?: 'social-starter';
}

export const StickyPlansColumnHeaders = ({ plans, stickyHeaderOffset, variant }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.style.setProperty('--plans-amount', plans.length.toString());
  }, [plans.length]);

  useEffect(() => {
    containerRef.current?.style.setProperty('--sticky-top-offset', `${stickyHeaderOffset}px`);
  }, [stickyHeaderOffset]);

  return (
    <div
      ref={containerRef}
      className={classNames('payflow-ui sticky-plans-column-headers', 'v3', {
        'with-badge': plans.some((plan) => plan.badgeText),
        'social-starter': variant === 'social-starter',
      })}
    >
      <PlanBadgeTextContainer plans={plans} />
      <Plans plans={plans} />
    </div>
  );
};
